import visa from "@/assets/visa.svg";
import mastercard from "@/assets/mastercard.svg";
import amex from "@/assets/amex.svg";
import card from "@/assets/card.svg";

export const getPaymentCardProviderImage = (provider: string) => {
	switch (provider) {
	case "visa":
		return visa;
	case "mastercard":
		return mastercard;
	case "amex":
		return amex;
	default:
		return card;
	}
};
